module.exports = __webpack_public_path__ + "img/xiejushiyongshenqing.189fbd2a.png";